import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ModeloDocumentoLookupResponse } from '../../responses/dfe/modelo-documento-lookup.response';

@Injectable({
  providedIn: 'root',
})
export class ModeloDocumentoService extends CommonService {
  private readonly apiUrl = `${environment.urlApiDFe}lookup/modelo-documento`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public listar(): Observable<ModeloDocumentoLookupResponse> {
    return this.httpClient
      .get<ModeloDocumentoLookupResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
